import React, {useEffect, useState} from "react";
import {useHistory, withRouter} from 'react-router-dom';




export const LandingPage = (props) => {
    let history = useHistory();
    const handleNavigateToApp = () => {
        history.push("/app");
    }
    const [loading,setLoading]=useState(true);


    useEffect(()=>{
        setLoading(true);
        const script = document.createElement("script");
        const scriptSweet = document.createElement("script");
        const scriptSplitbee = document.createElement("script");

        script.src = "assets/Js/main.js";
        script.async = true;
        scriptSweet.src = "https://cdn.jsdelivr.net/npm/sweetalert2@10/dist/sweetalert2.all.min.js";
        scriptSweet.async = true;
        scriptSplitbee.src = "https://cdn.splitbee.io/sb.js";
        scriptSplitbee.async = true;

        document.body.appendChild(scriptSweet);
        document.body.appendChild(script);
        document.body.appendChild(scriptSplitbee);
        setLoading(false);

    },[])
    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light navbar-custom fixed-top ">
                <div className="container d-flex justify-content-between">
                    <a className="" href="#"><img className="logoImg white-img animate__animated animate__zoomIn"
                                                  src="assets/img/Kulko-logo.svg" width="110" height="110"/></a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                            data-bs-target=".navbarNavAltMarkup" aria-controls="navbarNavAltMarkup"
                            aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse navbarNavAltMarkup" id="navbarNavAltMarkup"> </div>
                    <div className="collapse navbar-collapse navbarNavAltMarkup">
                        <div id="robe" className="navbar-nav d-flex justify-content-end ">
                            <button className="animate__animated animate__bounce nav-link mx-5 round-button fw-bolder text-nowrap"
                                    data-scroll-nav="0" rel="nofollow" onClick={handleNavigateToApp}>¡EMPIEZA AHORA!</button>
                        </div>
                    </div>

                </div>
            </nav>

            <main>
                <section>
                    <div className="hero container-fluid degrading-pink">
                        <div className="row">
                            <div className="hero_title text-center text-white mt-5 ">
                                <h1 className="fw-bolder">¡Crea tu catálogo online y comienza <span className="d-block">a vender por WhatsApp!</span>
                                </h1>
                            </div>
                            <div className="col-md text-center">
                                <div>
                                    <img src="assets/img/chico-top.png" alt="Responsive image"/>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xxl-6 col-md-6 col-sm-12 box">
                                <div className="box_1">
                                    <img className="" src="assets/img/dialog-top.png" alt="Responsive image"/>
                                        <div className="boxText" id="presentacion">
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container" id="imagenesInicio">

                    </div>
                </section>

                <section className="container" id="ofrecemos">
                    <div className="row justify-content-md-center text-center">
                        <div className="col-12 text-center">
                            <h3 className="pink-text2 mt-5 mb-5">
                                ¡Toma el control de tu tiempo, comisiones y ventas! <span className="d-block">
                        Comienza a ofrecer pedidos online en un abrir y cerrar de ojos.</span>
                            </h3>
                        </div>
                        <div className="grid mt-5" id="caracteristicas"></div>
                    </div>
                    <div className="row ">
                        <div className="col text-center">
                            <a href="https://kulko.app/app" target="_blank"
                               className=" start-button text-white mt-5 mt-5 ">¡COMIENZA AHORA!</a>
                        </div>
                    </div>
                </section>

                <section className="container fotoAndText">
                    <div className="row mt-5 mb-5 mx-5 align-items-center">
                        <div className="col-md-6 col-sm-12">
                            <h3 className="fw-bold mb-3">Gestiona tus pedidos en tu restaurante o a domicilio en
                                minutos</h3>
                            <p>Una herramienta fácil y sencilla, con un resultado poderoso. Obtén en pocos minutos, tu
                                carta digital con todo lo necesario para mostrar tus platos y servicios a tus
                                clientes.</p>
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <img className="float-left" src="assets/img/mozo.png"/>
                        </div>
                    </div>
                </section>

                <section className="container-fluid mt-5">
                    <div className="row">
                        <div className="col-12 text-center">
                            <img className="large-image" src="assets/img/mockup-kulko.png"/>
                        </div>
                    </div>
                </section>

                <section className="container fotoAndText">
                    <div className="row mt-5 mb-5 mx-5 align-items-center">
                        <div className="col-md-6 col-sm-12">
                            <img className="float-left" src="assets/img/mujer.png"/>
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <h3 className="fw-bold mb-3">Experiencia perfecta multiplataforma. Control total desde
                                cualquier dispositivo y sistema operativo.</h3>
                            <p>Una herramienta fácil y sencilla, con un resultado poderoso. Obtén en pocos minutos, tu
                                catálogo digital con todo lo necesario para mostrar tus productos y servicios a tus
                                clientes.</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col text-center">
                            <a href="https://kulko-fe-tst.netlify.app/KulkoTest" target="_blank"
                               className="start-button demo-button text-white mt-5 mt-5 ">VER DEMO</a>
                        </div>
                    </div>
                </section>

                <section className="container fotoAndText">
                    <div className="row mt-5 mb-5 mx-5 align-items-center">
                        <div className="col-md-6 col-sm-12">
                            <h3 className="fw-bold mb-3">Mejor posicionamiento de SEO.</h3>
                            <p>Facilitamos el posicionamiento de tu negocio en buscadores como Google, aumentando su
                                visibilidad y presencia online.</p>
                            <div className="grafico">
                                <img className="float-right mt-5" src="assets/img/graficos.png"/>

                                    <div className="numeros_1 text-white fw-bold">125K</div>
                                    <div className="numeros_2 text-white fw-bold">87K</div>
                                    <div className="numeros_3 text-white  fw-bold">4.8</div>
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <img className="float-left" src="assets/img/chica-joven.png"/>
                        </div>
                    </div>
                </section>

                <section className="container" id="precios">
                    <div className="row p-2">
                        <div className="col mb-5 mt-5 text-center">
                            <h3 className=" fw-bold">Precios simples y transparentes </h3>
                            <p>¡Salvemos a millones de emprendedores y pymes de las altas comisiones!</p>
                        </div>
                    </div>

                    <div className="row grid p-2" id="cardPrecios">
                    </div>
                    <p className="text-center p-4">*Por ejemplo: kulko.app/depositodebebidas</p>
                </section>

                <section className="container-fluid">
                    <div className="row">
                        <div className="col text-center">
                            <img className="large-image" alt="" src="assets/img/mockup-kulko1.png"/>
                        </div>
                    </div>
                </section>

                <section className="container-fluid preguntasFrecuentes" id="ayuda">
                    <div className="row">
                        <div className="col mt-5 text-center">
                            <h2 className="fw-bolder">Preguntas Frecuentes</h2>
                        </div>
                        <div className="row m-2 p-5">
                            <div className="col-md-6 col-sm-12" id="preguntas"></div>
                            <div className="col-md-6 col-sm-12" id="preguntasDos"></div>
                        </div>
                    </div>
                </section>

                <section className="container">
                    <div className="col mb-5 mt-5 text-center">
                        <h2 className="fw-bolder">¡Con <span className="pink-text">Kulko</span> es mas fácil!</h2>
                    </div>
                    <div className="row">
                        <div className="col text-center">
                            <img className="container-custom" alt="Responsive image" src="assets/img/morocho.png"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col text-center">
                            <a href="https://kulko.app/app" target="_blank"
                               className="start-button text-white mt-5 mt-5 ">¡EMPIEZA AHORA!</a>
                        </div>
                    </div>
                </section>

                <section className="container fotoAndText" id="contacto">
                    <div className="row mt-5 mb-5 align-items-center g-3">
                        <div className="col-md-5 col-sm-12 p-2">
                            <h3 className="fw-bold mb-3">¡Contáctanos!</h3>
                            <h4 className="pink-text mb-3">¡Obtén hoy tu propia tienda online!</h4>
                            <p>Completa los datos para que podamos responder a todas tus consultas a la brevedad.</p>
                        </div>

                        <div className="col-md-7 col-sm-12 round3" id="contact">
                        </div>
                    </div>
                </section>
            </main>

            <footer>
                <section className="container-fluid purple-background">
                    <div className="row p-5 align-items-center">
                        <div className="col-md col-sm-12 text-center">
                            <img className="small-image white-img" alt="Responsive image" src="assets/img/Kulko-logo.svg"/>
                        </div>
                        <div className="col-md col-sm-12 mb-1">
                            <a href="#precios" className="text-white fw-bold text-center text-decoration-none">
                                <span className="d-block">¡Comienza con</span>
                                <span className="d-block">7 días por tan</span>
                                <span className="d-block">sólo $1000 clp!</span>
                            </a>
                        </div>
                        <div className="col-md col-sm-12 border-left mt-2">
                            <p className="text-white fw-bold text-center"><a className="text-white text-decoration-none"
                                                                             href="https://docs.google.com/document/d/1sv2CL8RAGXF4AfrQNESQmZ9W40ZRCrq39KbWjPW43Lc/edit?usp=sharing">Política <span
                                className="d-block">de Privacidad</span></a></p>
                        </div>
                        <div className="col-md col-sm-12 border-left">
                            <p className="text-white fw-bold text-center"><a className="text-white text-decoration-none"
                                                                             href="https://docs.google.com/document/d/1hnUo5Lw9fsxojvbMkO2k7Go9RfyddLSUSMdBf6Gh1Os/edit?usp=sharing">Términos <span
                                className="d-block">de Servicio</span></a></p>
                        </div>
                        <div className="col-md col-sm-12 border-left text-center">
                            <a href="https://www.instagram.com/kulko.app/"><img className="white-img"
                                                                                alt="Responsive image"
                                                                                src="assets/img/instagram.svg"/></a>
                        </div>
                    </div>
                </section>
            </footer>



        </>
    )
}

export default withRouter(LandingPage)